import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { PRODUCT_PAYMENT_SETTINGS_QUERY_KEY } from './use-product-payment-settings-list.hook';

/**
 * Depois de salvar, atualiza tudo o que depende da config de pagamento: a tela,
 * o step Pagamento da proposta (config e combo de formas) e o histórico.
 */
export function useInvalidatePaymentSettings() {
  const queryClient = useQueryClient();

  return useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: PRODUCT_PAYMENT_SETTINGS_QUERY_KEY,
    });
    void queryClient.invalidateQueries({
      queryKey: ['product-payment-config'],
    });
    void queryClient.invalidateQueries({ queryKey: ['payment-types'] });
    void queryClient.invalidateQueries({ queryKey: ['audit-activities'] });
  }, [queryClient]);
}
